export enum OnHoldReason {
  REJECTED_DOCUMENTS = 'rejected_documents',
  NO_REPLY = 'no_reply_from_customer',
  LIGO_REQUEST = 'ligo_request',
  OTHER = 'other',
  NO_PRESENT = 'no_present'
}
